
import { useNavigate } from "react-router-dom";
import { SvgLogo } from "./SvgLogo";

interface LogoProps {
  className?: string;
  size?: "small" | "medium" | "large";
}

export function Logo({ className = "", size = "medium" }: LogoProps) {
  const navigate = useNavigate();
  
  return (
    <div 
      className={`flex items-center gap-2 cursor-pointer ${className}`}
      onClick={() => navigate("/")}
    >
      <SvgLogo size={size} />
    </div>
  );
}
